var VConsole = require('vconsole');

window.vConsole === undefined && (window.vConsole = new VConsole());
